export const API_BASE_URL = 'https://api-arb.art.art/arbit/api/v1';

export const API_URL_LOGIN = `${API_BASE_URL}/auth`;
export const API_URL_SIGNUP = `${API_BASE_URL}/registration`;
export const API_URL_SIGNUP_CONFIRMATION = `${API_BASE_URL}/confirmation`;
export const API_URL_LOGOUT = `${API_BASE_URL}/logout`;
export const API_URL_FORGOT = `${API_BASE_URL}/recovery`;
export const API_URL_FORGOT_CONFIRMATION = `${API_BASE_URL}/recovery_confirmation`;
export const API_URL_CAMPAIGN_LIST = `${API_BASE_URL}/webmaster/campaign.get_list`;
export const API_URL_SIGN_CAMPAIGN = `${API_BASE_URL}/webmaster/campaign.sign`;
export const API_URL_WEBMASTER_INFO = `${API_BASE_URL}/webmaster/info`;
export const API_URL_WEBMASTER_STAT_CAMPAIGN_DETAIL = `${API_BASE_URL}/webmaster/stat.campaign_detail`;
export const API_URL_WEBMASTER_SETTINGS = `${API_BASE_URL}/webmaster/settings`;
export const API_URL_WEBMASTER_SETTINGS_UPDATE = `${API_BASE_URL}/webmaster/settings.update`;
export const API_URL_WEBMASTER_PAYMENT_INFO = `${API_BASE_URL}/webmaster/payment.info`;
export const API_URL_WEBMASTER_PAYMENT_INFO_UPDATE = `${API_BASE_URL}/webmaster/payment.update_info`;
export const API_URL_WEBMASTER_GET_REFERRAL_LINK = `${API_BASE_URL}/webmaster/campaign.get_code`;

export default {
  languages: {
    default: 'en',
    list: new Map([
      ['en', 'English'],
      ['ru', 'Russian'],
      ['zh', 'Chinese'],
      ['es', 'Spanish'],
      ['fr', 'French'],
      ['de', 'German'],
      ['ar', 'Arabic'],
      ['it', 'Italian'],
    ]),
    dictionaries: ['ru', 'zh', 'es', 'fr', 'de', 'ar', 'it'],
  },
};

export const levels = new Map([
  ['bronze', [0, 500, 1000]],
  ['silver', [1000, 2500, 5000]],
  ['gold', [5000]],
]);

export const registrars = new Map([
  ['store.art', 'Store .ART'],
  ['onlydomains.com', 'OnlyDomains'],
  ['e.art', '.ART for China'],
  ['heartinternet.uk', 'HeartInternet (Host Europe Group)'],
  ['domaindiscount24.com', 'DD24 (Key-Systems)'],
  ['namecheap.com', 'Namecheap'],
  ['crazydomains.com', 'CrazyDomains'],
  ['instra.com', 'Instra Corporation Pty Ltd'],
  ['rebel.com', 'Super Registry'],
  ['sibername.com', 'Sibername'],
  ['webnames.ca', 'Webnames.ca'],
  ['hover.com', 'Tucows.com Co.'],
  ['internetx.com', 'InternetX'],
  ['uniteddomains.com', 'united-domains AG'],
  ['1and1.co.uk', '1&1 Internet'],
  ['1api.net', '1API GmbH'],
  ['ascio.com', 'Ascio Technologies'],
  ['entorno.es', 'Entorno Digital, SA'],
  ['ovh.co.uk', 'OVH'],
  ['gandi.net', 'Gandi SAS'],
  ['french-connexion.fr', 'French Connexion'],
  ['netim.com', 'NETIM'],
  ['bb-online.com', 'BB Online UK Limited'],
  ['astutium.com', 'Astutium'],
  ['discountdomainsuk.com', 'Discount Domains Ltd'],
  ['safenames.net', 'Safenames Ltd'],
  ['lexsynergy.com', 'Lexsynergy Limited'],
  ['alpnames.com', 'AlpNames Limited'],
  ['blacknight.com', 'Blacknight Internet Solutions'],
  ['101domain.com', '101domain GRS Limited'],
  ['domainthenet.com', 'Domain The Net Technologies LTD'],
  ['onamae.com', 'GMO'],
  ['uniregistry.com', 'Uniregistry'],
  ['eurodns.com', 'EuroDNS S.A.'],
  ['reg.ru', 'Registrar of Domain Names REG.RU, LLC'],
  ['nic.ru', 'RU-CENTER'],
  ['webnames.ru', 'Regtime Ltd'],
  ['nameisp.com', 'NameISP'],
  ['atakdomain.com', 'Atak Domain Hosting'],
  ['porkbun.com', 'Porkbun'],
  ['epik.com', 'Epik'],
  ['domainr.com', 'Domain Research LLC'],
  ['namesilo.com', 'NameSilo, LLC'],
  ['onlinenic.com', 'OnlineNIC'],
  ['enom.com', 'eNom, Inc.'],
  ['uk.godaddy.com', 'GoDaddy'],
  //
  // IDs
  //
  ['H33200632', 'Store .ART'],
  ['H20109039', 'OnlyDomains'],
  ['e.art', '.ART for China'],
  ['H445752', 'HeartInternet (Host Europe Group)'],
  ['H4854962', 'DD24 (Key-Systems)'],
  ['H1772673', 'Namecheap'],
  ['H3577883', 'CrazyDomains'],
  // ['H20109039', 'Instra Corporation Pty Ltd'],
  ['H3664432', 'Super Registry'],
  ['H15236791', 'Sibername'],
  ['H4380131', 'Webnames.ca'],
  ['H122260', 'Tucows.com Co.'],
  ['7145-IX-EUR', 'InternetX'],
  ['H67436-EUR', 'united-domains AG'],
  ['H7395011', '1&1 Internet'],
  ['H340803', '1API GmbH'],
  ['H87165', 'Ascio Technologies'],
  ['H959214-EUR', 'Entorno Digital, SA'],
  ['H21084561', 'OVH'],
  ['H1167922-EUR', 'Gandi SAS'],
  ['H2741737', 'French Connexion'],
  ['H20109045', 'NETIM'],
  ['I346', 'BB Online UK Limited'],
  ['H63503', 'Astutium'],
  ['H87623', 'Discount Domains Ltd'],
  ['I34390', 'Safenames Ltd'],
  ['H142975', 'Lexsynergy Limited'],
  ['H17615029', 'AlpNames Limited'],
  ['H116797', 'Blacknight Internet Solutions'],
  ['H10515845', '101domain GRS Limited'],
  ['H21159746', 'Domain The Net Technologies LTD'],
  ['H1605993', 'GMO'],
  ['H9376925', 'Uniregistry'],
  ['H1665238-EUR', 'EuroDNS S.A.'],
  ['H2440764', 'Registrar of Domain Names REG.RU, LLC'],
  ['H1319026', 'RU-CENTER'],
  ['H2445014', 'Regtime Ltd'],
  ['H90404', 'NameISP'],
  ['H69548449', 'Atak Domain Hosting'],
  ['H22460759', 'Porkbun'],
  ['H3772472', 'Epik'],
  ['H41869639', 'Domain Research LLC'],
  ['H17846899', 'NameSilo, LLC'],
  ['H3728806', 'OnlineNIC'],
  ['7065-EN', 'eNom, Inc.'],
  ['H3105376', 'GoDaddy'],
  ['H6233917', 'GoDaddy'],
  ['H6233920', 'GoDaddy'],
  ['H6233923', 'GoDaddy'],
  ['H6233914', 'GoDaddy'],
]);



// WEBPACK FOOTER //
// ./src/config.js